type Props = {
  jsonLD: Parameters<typeof JSON.stringify>[0];
};

export const JsonLD = ({ jsonLD }: Props) => {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }} />;
};
